import PageHeader from "@/components/shared/PageHeader";
import EmptyState from "@/components/shared/EmptyState";

export default function TerritorioArvoresPage() {
  return (
    <div className="space-y-5">
      <PageHeader
        title="Território > Árvores"
        subtitle="Objetos arbóreos detectados nas inspeções territoriais do Setor Bela Vista."
      />
      <EmptyState
        icon="ri-plant-line"
        title="Tela em construção"
        description="Esta tela vai listar as árvores detectadas por inspeção territorial, com localização estimada, espécie (quando identificável) e nível de confiança. Por enquanto, veja os objetos detectados dentro do detalhe de cada inspeção em Território > Inspeções."
      />
    </div>
  );
}
